package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface ConsentV2FusedEnvironment : Environment {
    val host: String
    val proxyHost: String
    val apiKey: String
    val envPath: String
    val apiVersion: String
}

@JsExport
abstract class BaseConsentV2FusedEnvironment(override val apiVersion: String = "v2") : ConsentV2FusedEnvironment

@JsExport
data class DevConsentV2FusedEnvironment(
    override val host: String = "dev.consent.cs.vizio.com",
    override val proxyHost: String = "dev.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management",
    override val apiKey: String
) : BaseConsentV2FusedEnvironment()

@JsExport
data class StageConsentV2FusedEnvironment(
    override val host: String = "stage.consent.cs.vizio.com",
    override val proxyHost: String = "stage.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management",
    override val apiKey: String
) : BaseConsentV2FusedEnvironment()

@JsExport
data class PreProdConsentV2FusedEnvironment(
    override val host: String = "pre-prod.consent.cs.vizio.com",
    override val proxyHost: String = "preprod.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management",
    override val apiKey: String
) : BaseConsentV2FusedEnvironment()

@JsExport
data class ProdConsentV2FusedEnvironment(
    override val host: String = "prod.consent.cs.vizio.com",
    override val proxyHost: String = "prod.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management",
    override val apiKey: String
) : BaseConsentV2FusedEnvironment()

fun chooseConsentV2FusedEnvironment(envConfig: ConsentV2FusedEnvironmentConfig): ConsentV2FusedEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdConsentV2FusedEnvironment(apiKey = envConfig.apiKey)
        EnvironmentGroup.PREPROD -> PreProdConsentV2FusedEnvironment(apiKey = envConfig.apiKey)
        EnvironmentGroup.STAGE -> StageConsentV2FusedEnvironment(apiKey = envConfig.apiKey)
        EnvironmentGroup.DEV -> DevConsentV2FusedEnvironment(apiKey = envConfig.apiKey)
        EnvironmentGroup.TEST -> TODO("Test Environment for Consent not defined yet!")
    }
}